export const API_CACHING_TAGS = [
  "User",
  "Account",
  "AccountUsers",
  "Articles",
  "Templates",
  "Dashboard",
  "Destinations",
];
